export const GET_CAMPAIGN = 'GET_CAMPAIGN';
